import type { Option } from './types';

type ComboboxTagProps = {
  option: Option;
  onRemove: (option: Option) => void;
};

const ComboboxTag = ({ option, onRemove }: ComboboxTagProps) => {
  return (
    <label
      htmlFor="combobox-tag"
      data-testid={`combobox-chip-${option.id}`}
      className="px-2 py-1 rounded flex items-center text-xs border-[1px] border-black/50 font-medium hover:cursor-pointer"
      onClick={() => onRemove(option)}
    >
      <input
        type="checkbox"
        className="sr-only"
        name="combobox-tag"
        id="combobox-tag"
        checked={true}
        aria-label={`Remove ${option.name} from selection`}
        readOnly
      />
      <span className="max-w-[150px] whitespace-nowrap overflow-hidden text-ellipsis">
        {option.name}
      </span>
      <span className="ml-1 text-xs">×</span>
    </label>
  );
};

export default ComboboxTag;
